// TODO: Overhaul — delete this file once `/v1/investments/rates` is served. Interim, it maps the live
// brochure statistics (API2 `/v2/statistics/brochure`) onto the overhaul rates shape so the create flow can
// build against the real numbers ahead of the endpoint. At cut-over, drop it from the overhaul seam and the
// rates query flows to the real `ACCOUNT_OVERHAUL_CLIENT` unchanged.
import { Client } from 'openapi-fetch';

import { ok } from '@views/investor/queries/overhaul-mock.util';

import {
  SquirrelMoneyContractsTypesInvestmentClasses as InvestmentClasses,
  SquirrelMoneyCoreContractsInvestmentInterestRateDto as InvestmentInterestRateDto,
  paths as accountOverhaulPaths,
} from '@core/schemas/account-overhaul-schema';
import { paths as api2Paths } from '@core/schemas/api2-schema';

/**
 * A mock `ACCOUNT_OVERHAUL_CLIENT` fragment serving `GET /v1/investments/rates` from the live brochure
 * statistics, keyed by `InvestmentClass`: Home Loan ← the 7-year rate, Construction Loan ← the 2-year rate,
 * Personal Loan ← the 5–7-year personal rate. The brochure carries no specialised-loan rate, so that class is
 * left out. Composed into the single overhaul seam (`createOverhaulMockClient`); handles only the rates GET.
 */
export function createInvestmentRatesMockClient(options: { api2: Client<api2Paths> }): Client<accountOverhaulPaths> {
  const { api2 } = options;
  return {
    async GET() {
      const { data } = await api2.GET('/v2/statistics/brochure');
      const rates: InvestmentInterestRateDto[] = [
        { investmentClass: InvestmentClasses.ResidentialMortgage, interestRate: data?.home7YearRate },
        { investmentClass: InvestmentClasses.CommercialMortgage, interestRate: data?.business2YearRate },
        { investmentClass: InvestmentClasses.ConsumerLoan, interestRate: data?.personal5x7YearRate },
      ];
      return ok(rates);
    },
    // Cast: this stub implements only the rates GET, not the whole overhaul surface.
  } as unknown as Client<accountOverhaulPaths>;
}
